export function updateAllAriaLabels() {
  document.querySelectorAll('a, button').forEach((el: HTMLElement) => {
    let visibleText = el.innerText || '';
    visibleText = visibleText.replace(/\.(.*?)\{.*?\}/g, '');
    visibleText = visibleText
      .replace(/\s+/g, ' ')
      .replace(/\u00a0/g, ' ')
      .trim();

    const ariaLabel = el.getAttribute('aria-label');
    if (visibleText && (!ariaLabel || ariaLabel.trim() !== visibleText)) {
      el.setAttribute('aria-label', visibleText);
    }
  });
}
